import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { toDateString } from 'app/shared/utils/date';
import { toReadableNumber } from 'app/shared/utils/number';
import styles from './earnings.module.css';

const EarningsSkeleton = () => (
  <div className={styles.list}>
    {[1, 2, 3].map((i) => (
      <div key={i} className={styles.row}>
        <div className={styles.rowMain}>
          <Skeleton width={130} height={13} />
          <Skeleton width={80} height={11} style={{ marginTop: 6 }} />
        </div>
        <Skeleton width={70} height={14} />
      </div>
    ))}
  </div>
);

export const RecentEarnings = ({ items = [], loading = false }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <span className={styles.title}>Recent settled earnings</span>
      </div>

      {loading ? (
        <EarningsSkeleton />
      ) : items.length === 0 ? (
        <div className={styles.empty}>
          <p className={styles.emptyBody}>No settled earnings yet.</p>
        </div>
      ) : (
        <div className={styles.list}>
          {items.map((earning) => {
            const currency = earning.currency?.code || earning.currency || '';
            return (
              <div key={earning.id} className={styles.row}>
                <div className={styles.rowMain}>
                  <span className={styles.client}>
                    {earning.tenant?.name || earning.organisation?.name || 'Earning'}
                  </span>
                  <span className={styles.date}>
                    {toDateString(earning.created_on || earning.time_stamp)}
                  </span>
                </div>
                <span className={styles.amount}>
                  {currency ? `${currency} ` : ''}
                  {toReadableNumber(Number(earning.amount))}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
